export const canNavigateBack = () => {
  // eslint-disable-next-line no-restricted-globals
  return 'history' in window && history.state && history.state.idx > 0;
};
